import { render, staticRenderFns } from "./navCatalogueItem.vue?vue&type=template&id=ab3b41f8&"
import script from "./navCatalogueItem.vue?vue&type=script&lang=js&"
export * from "./navCatalogueItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/nav/items/navCatalogueItem.vue"
export default component.exports